import { ProjectChatUiContext } from "@/model/project/chat";

export type AllowedChatContextValue =
    | { [key: string]: AllowedChatContextValue }
    | string
    | number
    | boolean
    | undefined
    | null;
export type ChatContextType = { [key: string]: AllowedChatContextValue } | undefined;

export enum ChatType {
    General = "general",
    CreateProject = "create-project",
    Agent = "agent",
}

// ensure every ChatType member is represented

type GeneralChatContext = { projectId: string; uiContext: ProjectChatUiContext };
export type ChatTypeToContextMap = {
    [ChatType.General]: GeneralChatContext;
    [ChatType.CreateProject]: { reviseProjectId?: string };
    [ChatType.Agent]: GeneralChatContext & { agentId: string };
};

export type ChatContext<T extends ChatType> = ChatTypeToContextMap[T];
